<template>
    <div class="icon_button_container">
        <el-button type="primary" @click.stop="doClick">
            <template #default>
            <div class="icon_button">
                <img :src="iconSrc" alt="" v-if="iconSrc"/>
                <slot></slot>
            </div>
            </template>
        </el-button>
    </div>
</template>
<script>
import { ElButton } from 'element-plus';
export default {
  components: {
    
    ElButton,
  },
    props: {
      iconSrc:{
        type: String
      },
      size: {
        type: String,
        default: "middle",
      },
      type: {
        type: String,
        default: "primary",
      },
      round: {
        type: Boolean,
        default: true,
      },
    },
    methods:{
        doClick(){
            this.$emit("doClick");
        }
    }
}
</script>
<style>
.icon_button_container {
  width: 100%;
  height: 100%;
}
.icon_button_container button {
  width: 100%;
  height: 100% !important;
  min-height: 30px !important;
}
.icon_button_container .el-button {
  /* background: url("../../assets/images/login/btn.png"); */
  background-size: 100% 100%;
  border: none !important;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon_button_container .el-button.is-round{
  padding: 0 !important;
}
.icon_button{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
  font-size: 15px;
}
.icon_button img{
  height: 100%;
  width: auto;
  margin-right: 7px;
}
</style>